<tt-field-group v-bind="{ id, describedbyId, errorText, hintText, label, required }">
  <input class="tt-o-text-field" :class="{'tt-o-text-field--success': success}"
         :aria-required="required ? 'true' : 'false'"
         :aria-invalid="errorText ? 'true' : 'false'"
         type="text"
         @input="updateValue"
         v-bind="{id, 'aria-describedby': describedbyIdValue, name, disabled, value: modelValue}">
</tt-field-group>
